export default (): void => {
  window.setTimeout(() => {
    document.querySelectorAll('main')?.item(0)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }, 200)
}
